import moment from "moment-timezone";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
const { CONFIG } = require("./config");

moment.defaultFormat = "YYYY-MM-DDTHH:mm:ss.SSSZ";
moment.tz.setDefault(CONFIG.TIMEZONE);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
